import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import "./lib/i18n";
import { App } from "./App";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element in index.html");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
